import {COINS_COLOR, WAR_COLOR} from "./constants";
import {SUCCUBES_SEDUCTION_RESULT_COLOR} from "../configs/factions/succubes";

export const UNIT_LABEL_TEXT_STYLE = {
  fontSize: '32px',
  fontFamily: 'Franklin Gothic Heavy',
  color: '#ffffff',
  fontStyle: 'bold'
}
// Отметка пропуска хода «zZ» над правым плечом отряда (change
// unit-auto-selection): белая без подложки, с темной обводкой, как значки над
// полем. Маленькая «z» — ниже и левее большой
export const UNIT_SKIP_MARK_STYLE = {
  fontFamily: 'Franklin Gothic Heavy',
  color: '#ffffff',
  stroke: '#000000',
  strokeThickness: 5,
};

export const UNIT_LABEL_DAMAGE_STYLE = {
  fontSize: '32px',
  fontFamily: 'Franklin Gothic Heavy',
  color: WAR_COLOR,
  fontStyle: 'bold'
}

// Отдельный цвет (не WAR_COLOR), чтобы результат попытки соблазнения нельзя
// было спутать с уроном ближнего боя, использующим тот же тип маркера
export const UNIT_LABEL_SEDUCTION_STYLE = {
  fontSize: '32px',
  fontFamily: 'Franklin Gothic Heavy',
  color: SUCCUBES_SEDUCTION_RESULT_COLOR,
  fontStyle: 'bold'
}

export const UNIT_LABEL_TEN_AND_MORE_TEXT_STYLE = {
  fontSize: '28px',
  fontFamily: 'Franklin Gothic Heavy',
}

const SIZE_RECRUITMENT_TEXT_STYLE = {
  fontSize: '48px',
  fontFamily: 'Franklin Gothic Heavy',
  fontStyle: 'bold'
}
export const SIZE_RECRUITMENT_MARKER_SIZE_TEXT_STYLE = {
  ...SIZE_RECRUITMENT_TEXT_STYLE,
  // Белые цифры красит золотым перелив tint (см. configs/sizeRecruitmentMarker)
  fill: '#ffffff',
  stroke: '#160b03',
  strokeThickness: 8,
}
export const SIZE_RECRUITMENT_MARKER_PRICE_TEXT_STYLE = {
  ...SIZE_RECRUITMENT_TEXT_STYLE,
  color: COINS_COLOR,
  stroke: '#160b03',
  strokeThickness: 8,
}

export const INCOME_TEXT_STYLE = {
  fontSize: '70px',
  fontFamily: 'Franklin Gothic Heavy',
  fontStyle: 'bold'
};
export const INCOME_TEXT_FRACTIONAL_STYLE = {
  fontFamily: 'Arial',
};
export const COORDS_TEXT_STYLE = {
  fontSize: '60px',
  fontFamily: 'Franklin Gothic Heavy',
  fontStyle: 'bold'
};

